export const getLayoutStyle = () => {
  const element = document.getElementsByTagName("body")[0];

  // element.classList.add("remove-this-class");
};
